import React from "react";

import { ApolloProvider } from "@apollo/client";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import RbAlertProvider from "components/RbAlertProvider";
import RbSnackbarProvider from "components/RbSnackbarProvider";
import RbThemeConfigProvider from "components/RbThemeConfigProvider";
import client from "config/client";
import MainScreen from "screens/MainScreen";
import SignInScreen from "screens/SignInScreen";

function App() {
  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <RbThemeConfigProvider>
          <RbAlertProvider>
            <RbSnackbarProvider>
              <Switch>
                <Route path="/login">
                  <SignInScreen />
                </Route>
                <Route path="/">
                  <MainScreen />
                </Route>
              </Switch>
            </RbSnackbarProvider>
          </RbAlertProvider>
        </RbThemeConfigProvider>
      </BrowserRouter>
    </ApolloProvider>
  );
}

export default App;
